export default __webpack_public_path__ + "static/media/homepage_module_scheduling.3d657e90.png";